import { render, staticRenderFns } from "./le-price-choose.vue?vue&type=template&id=6ca1f0d5&"
import script from "./le-price-choose.vue?vue&type=script&lang=js&"
export * from "./le-price-choose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports